export default __webpack_public_path__ + "static/media/doge_small.34f99562.png";